module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/hall-list/plan-ceremony-lineup-kyushu-1-6b7087d945c77ec6ccde4a93e8fbad90.png";